import { createElement } from "react";
function kebabToCamelCase(str) {
  return str.replace(/-([a-z])/g, (_, $1) => $1.toUpperCase());
}
function reactAttributes(obj) {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (key === "style" && typeof value === "string") {
      acc.style = value.split(";").reduce((styleAcc, item) => {
        const [styleKey, styleValue] = item.split(":");
        if (styleKey && styleValue) {
          styleAcc[kebabToCamelCase(styleKey.trim())] = styleValue.trim();
        }
        return styleAcc;
      }, {});
    } else {
      acc[kebabToCamelCase(key)] = value;
    }
    return acc;
  }, {});
}
function renderPaths(nodes) {
  if (!nodes) return;
  return nodes.map(
    (node) => createElement(node.tag, reactAttributes(node.att), renderPaths(node.nds))
  );
}
export {
  renderPaths
};
